var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export function Say(_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.05222 7.96701C6.05222 7.29444 7.00048 7.07812 10.0699 7.07812C13.2966 7.07812 15.8884 7.88681 15.8884 7.88681L16.0883 7.82431V5.77847C16.0883 5.77847 13.7046 5 10.0147 5C6.51549 5 3.33301 5.50243 3.33301 8.31354C3.33301 11.0854 5.63572 11.1222 10.654 11.1222C13.174 11.1222 14.3638 11.1122 14.3638 11.9389C14.3638 12.6993 12.9254 12.9194 9.90309 12.9194C5.87767 12.9194 3.58379 11.9503 3.58379 11.9503L3.38825 12.042V14.1781L3.47147 14.2028C5.19676 14.716 7.52083 15 10.0147 15C14.9677 15 17.083 14.2927 17.083 11.7118C17.083 9.10556 15.1423 8.76562 9.79004 8.76562C7.01963 8.76562 6.05222 8.7309 6.05222 7.96701Z", fill: color }) })));
}
